export enum Week {
First,
Second,
Third,
Fourth,
}
